const e={lastWeek:"'last' eeee 'at' p",yesterday:"'yesterday at' p",today:"'today at' p",tomorrow:"'tomorrow at' p",nextWeek:"eeee 'at' p",other:"P"},t=(t,a,o,r)=>e[t];export{t as formatRelative};
//# sourceMappingURL=formatRelative.js.map
